<template>

    <div v-if="loading" class="loading-overlay">
        LOADING...
        <span class="loader"></span>
    </div>
    <div v-else>
        <TankStatusGrid :data-source="containers" :properties="properties" key-expr="containerId"
            :state-storage-key="storageKey" :default-column-config="defaultColumnConfig" :show-status-filters="!isOperator"
            :column-fixing-enabled="!isOperator" :column-resizing-mode="dataGridColResizeMode" :height-offset="210"
            :use-default-column-config-only="false" @row-click="datagridRowClick" @refresh-data="refreshData"
            @grid-initialized="setGridInstance" @content-ready="dataReady" @select-container="onSelectContainer" />
    </div>
    
</template>

<script>
// import TankStatusGrid from '@/components/container/tank-status-grid.vue';
import TankStatusGrid from './tank-status-grid.vue';

export default {
    components: {
        TankStatusGrid
    },
    props: {
        typeId: {
            type: Number,
            default: 1
        },
        isOperator: {
            type: Boolean,
            default: false
        }
    },
    created() {
    },
    mounted() {
        this.loadData();
    },
    data() {
        return {
            dataGridColResizeMode: 'widget',
            dataGridInstance: null,
            datagridRowCount: 0,
            properties: [],
            // containers: [],
            currentContainer: "",
            savedState: "",
            stateOpen: false,
            defaultState: "",
            loading: true
        };
    },
    computed: {
        storageKey() {
            return this.isOperator ? 'rep_status_container_grid_view_operator-bulk' : 'grid-status-bulk';
            // return this.isOperator ? 'rep_status_container_grid_view_operator' : 'grid-status';
        },
        defaultColumnConfig() {
            let columnConfig =
            {
                'operator': {
                    visible: true,
                    caption: 'Operator',
                    minWidth: 125,
                    alignment: 'left'
                },
                'area': {
                    visible: true,
                    caption: 'Area',
                    minWidth: 125,
                    alignment: 'left'
                },
                'devices': {
                    visible: true,
                    caption: 'Devices',
                    minWidth: 125,
                    alignment: 'left'
                },
                'surface': {
                    visible: true,
                    caption: 'Surface',
                    minWidth: 150,
                    alignment: 'left',
                    allowReordering: true
                },
            }
            if (this.isOperator) {
                columnConfig = {
                    ...columnConfig,
                    'downhole lsd': {
                        visible: true,
                        caption: 'Downhole LSD',
                        minWidth: 150,
                        alignment: 'left'
                    },
                    'product': {
                        visible: true,
                        caption: 'Product',
                        minWidth: 100,
                        alignment: 'left'
                    },
                    'capacity': {
                        visible: true,
                        caption: 'Capacity',
                        minWidth: 100,
                        alignment: 'left'
                    },
                    'volume (%)': {
                        visible: true,
                        caption: 'Volume (%)',
                        minWidth: 100,
                        alignment: 'left'
                    },
                    'dte': {
                        visible: true,
                        caption: 'DTE',
                        minWidth: 100,
                        alignment: 'left'
                    },
                    'injection avg': {
                        visible: true,
                        caption: 'Injection',
                        minWidth: 100,
                        alignment: 'left'
                    },
                    'injection target': {
                        visible: true,
                        caption: 'Target Injection',
                        alignment: 'left'
                    },
                    'last device communication': {
                        visible: true,
                        caption: 'Last Communication',
                        minWidth: 100,
                        alignment: 'left'
                    },
                    'last24': {
                        visible: true,
                        caption: 'Last 24',
                        minWidth: 100,
                        alignment: 'left'
                    },
                    'last48': {
                        visible: true,
                        caption: 'Last 48',
                        minWidth: 100,
                        alignment: 'left'
                    },
                    'last72': {
                        visible: true,
                        caption: 'Last 72',
                        minWidth: 100,
                        alignment: 'left'
                    }
                };
            }
            return columnConfig;
        },
        containersFromStore() {
            return this.$store.getters["containers/getContainersV2"];
        },
        keepProps() {
            return this.$store.getters["properties/getProperties"]
                .filter(x => x.containerTypeId == this.typeId && x.uiShowList == true && x.appliesTo == 'C')
                .map(x => x.propertyName.toLowerCase())
                .sort();
        },
        numberProps(){
            return this.$store.getters["properties/getProperties"]
                .filter(x => x.propertyType == 'NUMBER' || x.propertyType == 'DECIMAL')
                .map(x => x.propertyName.toLowerCase())
                .sort();
        },
        containers() {
            if(this.$store.getters["containers/getContainersV2"]===undefined || this.$store.getters["containers/getContainersV2"]==null)
                return []
            
            const c = JSON.parse(JSON.stringify(this.$store.getters["containers/getContainersV2"]));
                console.log("Containers",c)

            for (const i in c) {
                var propNames = Object.keys(c[i].properties);
                for (const j in propNames) {
                    if (this.keepProps.includes(propNames[j])) {
                        if (this.numberProps.includes(propNames[j]))
                            c[i][propNames[j]] = Number(c[i].properties[propNames[j]]);
                        else
                            c[i][propNames[j]] = c[i].properties[propNames[j]];
                    }
                }
                delete c[i].properties
            }

            return c;
        }

    },
    watch: {
        containersFromStore: {
            handler(newValue, oldValue) {
                if (!oldValue || newValue === oldValue || !newValue || newValue.length === 0 || JSON.stringify(newValue) === JSON.stringify(oldValue)) {
                    return;
                }

                if (JSON.stringify(newValue) !== JSON.stringify(oldValue)) {
                    this.refreshData();
                }
            },
            deep: true
        }
    },
    methods: {
        onSelectContainer(containerId) {
            console.log(containerId);
        },
        onExporting(e) {
            e.fileName = "TankStatusDataExport"
        },
        dataReady(e) {
            this.datagridRowCount = this.dataGridInstance.totalCount();
        },

        setGridInstance(e) {
            this.dataGridInstance = e.component;
            this.dataGridInstance.columnOption(0, 'allowHeaderFiltering', false);
        },

        removeFilter() {
            this.dataGridInstance.clearFilter();
            this.dataGridInstance.clearSorting();
        },

        refreshData() {
            this.loadData(true);
        },
        datagridRowClick(e) {
            // getVisibleRows().map(row => row.data); returns a list of the CURRENT PAGE OF THE GRID
            this.$store.dispatch("containers/setContainersFilteredList", e.component.getVisibleRows().map(row => row.data.containerId))
            const selectedContainer = e.component.getSelectedRowsData()[0];
            this.$emit('select-container', selectedContainer.containerId);
        },
        setProperties() {
            console.log("status-grid.setProperties")
            let retVal = [];
            let flds = this.$store.getters["properties/getProperties"];
            console.log("status-grid.setProperties.flds", flds)
            for (let i = 0; i < flds.length; i++) {
                if (flds[i].uiShowList && flds[i].appliesTo == "C" && flds[i].containerTypeId == this.typeId) {
                    retVal.push(flds[i].propertyName);
                }
            }
            this.properties = retVal;
        },
        async loadData(refresh = false) {
            try {
                this.loading = true;
                await Promise.all([
                    this.$store.dispatch("containers/loadContainersStatusV2", { typeId: 2 }),
                    this.$store.dispatch("properties/loadProperties"),
                    this.$store.dispatch("userState/loadUserState", { id: 'containerStatusV2' })
                ])

                // const keepProps = await this.$store.getters["properties/getProperties"]
                //     .filter(x => x.containerTypeId == 1 && x.uiShowList == true && x.appliesTo == 'C')
                //     .map(x => x.propertyName.toLowerCase())
                //     .sort();

                // const numberProps = await this.$store.getters["properties/getProperties"]
                //     .filter(x => x.propertyType == 'NUMBER' || x.propertyType == 'DECIMAL')
                //     .map(x => x.propertyName.toLowerCase())
                //     .sort();

                // const storeContainers = await this.$store.getters["containers/getContainersV2"];
                // const c = JSON.parse(JSON.stringify(storeContainers));

                // for (const i in c) {
                //     var propNames = Object.keys(c[i].properties);
                //     for (const j in propNames) {
                //         if (keepProps.includes(propNames[j])) {
                //             if (numberProps.includes(propNames[j]))
                //                 c[i][propNames[j]] = Number(c[i].properties[propNames[j]]);
                //             else
                //                 c[i][propNames[j]] = c[i].properties[propNames[j]];
                //         }
                //     }
                //     delete c[i].properties
                // }

                // this.containers = c;
                this.properties = this.keepProps;

            } catch (error) {
                this.error = error.message || "Unexpected Error.";
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>

<style scoped>
.loading-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 200px;
    font-size: 16px;
    color: #666;
}

.loader {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: inline-block;
  position: relative;
  border: 3px solid;
  border-color: #FFF #FFF transparent;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;
}
.loader::after {
  content: '';
  box-sizing: border-box;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  border: 3px solid;
  border-color: transparent darkorange white;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  animation: rotationBack 0.5s linear infinite;
  transform-origin: center center;
}

@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@keyframes rotationBack {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(-360deg);
  }
}

.loading-overlay {
  position: fixed;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  color: #aaaaaa;
  font-size: 0.85rem;
  letter-spacing: 0.1em;
  z-index: 50;
}

.loading-overlay.error {
  color: #ff6b6b;
}
</style>
